import * as AirbnbData from "./airbnb/data";
import * as AirbnbContent from "./airbnb/content";

import * as AirbnbGlobalEurData from "./airbnb/pages/global/eur/data";
import * as AirbnbGlobalEurContent from "./airbnb/pages/global/eur/content";
import * as AirbnbGlobalGbpData from "./airbnb/pages/global/gbp/data";
import * as AirbnbGlobalGbpContent from "./airbnb/pages/global/gbp/content";
import * as AirbnbGlobalUsdData from "./airbnb/pages/global/usd/data";
import * as AirbnbGlobalUsdContent from "./airbnb/pages/global/usd/content";

import * as AirbnbUkAllData from "./airbnb/pages/uk/all/data";
import * as AirbnbUkAllContent from "./airbnb/pages/uk/all/content";

import * as AirbnbUkLondonlData from "./airbnb/pages/uk/london/data";
import * as AirbnbUkLondonContent from "./airbnb/pages/uk/london/content";

import * as RentalData from "./rental/data";
import * as RentalContent from "./rental/content";

import * as RentalGlobalAllData from "./rental/pages/global/all/data";
import * as RentalGlobalAllContent from "./rental/pages/global/all/content";

import * as RentalUkAllData from "./rental/pages/uk/all/data";
import * as RentalUkAllContent from "./rental/pages/uk/all/content";

import * as RentalUkLondonData from "./rental/pages/uk/london/data";
import * as RentalUkLondonContent from "./rental/pages/uk/london/content";

import * as RentalUsAllData from "./rental/pages/us/all/data";
import * as RentalUsAllContent from "./rental/pages/us/all/content";

const research = {
  airbnbdata: AirbnbData,
  airbnbcontent: AirbnbContent,

  airbnbglobaleurdata: AirbnbGlobalEurData,
  airbnbglobaleurcontent: AirbnbGlobalEurContent,
  airbnbglobalgbpdata: AirbnbGlobalGbpData,
  airbnbglobalgbpcontent: AirbnbGlobalGbpContent,
  airbnbglobalusddata: AirbnbGlobalUsdData,
  airbnbglobalusdcontent: AirbnbGlobalUsdContent,

  airbnbukalldata: AirbnbUkAllData,
  airbnbukallcontent: AirbnbUkAllContent,

  airbnbuklondondata: AirbnbUkLondonlData,
  airbnbuklondoncontent: AirbnbUkLondonContent,

  rentaldata: RentalData,
  rentalcontent: RentalContent,

  rentalglobalalldata: RentalGlobalAllData,
  rentalglobalallcontent: RentalGlobalAllContent,

  rentalukalldata: RentalUkAllData,
  rentalukallcontent: RentalUkAllContent,

  rentaluklondondata: RentalUkLondonData,
  rentaluklondoncontent: RentalUkLondonContent,

  rentalusalldata: RentalUsAllData,
  rentalusallcontent: RentalUsAllContent,
};

export function getResearchData(props, setState) {
  const { story, country, category } = props.match.params;

  const storyData = research[`${story}data`];
  const storyContent = research[`${story}content`];

  const data = research[`${story}${country}${category}data`];
  const content = research[`${story}${country}${category}content`];

  setState({
    data: storyData.calculateAdditionalData(data.rows),
    columns: storyData.addAdditionalColumns(
      data.columns,
      data.currencyFormatter,
    ),
    content: storyContent.addAdditionalContent(content),
  });
}
